import { JWMButton, ServiceLink } from "@components/JWMButton/JWMButton";
import classnames from "classnames";
import React from "react";

import style from "./style.module.scss";

interface CMSButtonProps {
    buttonProps: {
        color: "primary" | "secondary" | "accent";
        variant: "contained" | "outlined";
    };
    link: {
        anchor_id: string;
        external: boolean;
        id: string;
        title: string;
        url: string;
        url_prefix: string;
    };
    serviceLink?: ServiceLink;
    text: string;
}

interface Props {
    horizontal_alignment: string;
    buttons: CMSButtonProps[];
}

export const ButtonCollection = (props: Props): JSX.Element => {
    const { horizontal_alignment, buttons } = props;

    return (
        <div
            className={classnames(
                style.element,
                style[`horizontal_align_${horizontal_alignment?.toLocaleLowerCase() || "start"}`],
            )}
            data-test-id="button-collection"
        >
            {buttons?.length
                ? buttons.map((button, i) => {
                      return (
                          <div className={style.button} key={i}>
                              <JWMButton
                                  buttonProps={button?.buttonProps}
                                  text={button?.text}
                                  url={button?.link?.url}
                                  external={button?.link?.external}
                                  url_prefix={button?.link?.url_prefix}
                                  anchor_id={button?.link?.anchor_id}
                                  serviceLink={button?.serviceLink}
                              />
                          </div>
                      );
                  })
                : ""}
        </div>
    );
};

export default ButtonCollection;
